import type { IconProps } from '../types/IconProps.ts';
export const PauseCircle: IconProps = {
    name: 'PauseCircle',
    children: [
        `<path d="M10 9v6M14 9v6" />`,
        `<circle cx="12" cy="12" r="10" />`,
    ]
};